module.exports = __webpack_public_path__ + "img/KSC00856.f923fa74.jpg";